// src/Redux/action/EmailSchedulerAction.js
import { doAction, doResponseAction } from ".";

const UPDATE_EMAIL_SCHEDULE_REQUEST = 'UPDATE_EMAIL_SCHEDULE_REQUEST';
const UPDATE_EMAIL_SCHEDULE_SUCCESS = 'UPDATE_EMAIL_SCHEDULE_SUCCESS';
const UPDATE_EMAIL_SCHEDULE_FAILURE = 'UPDATE_EMAIL_SCHEDULE_FAILURE';
const LIST_EMAIL_SCHEDULES_REQUEST = 'LIST_EMAIL_SCHEDULES_REQUEST';
const LIST_EMAIL_SCHEDULES_SUCCESS = 'LIST_EMAIL_SCHEDULES_SUCCESS';
const LIST_EMAIL_SCHEDULES_FAILURE = 'LIST_EMAIL_SCHEDULES_FAILURE';
const CLEAR_EMAIL_SCHEDULE_ERRORS = 'CLEAR_EMAIL_SCHEDULE_ERRORS'; // Fixed typo

export {
    UPDATE_EMAIL_SCHEDULE_REQUEST,
    UPDATE_EMAIL_SCHEDULE_SUCCESS,
    UPDATE_EMAIL_SCHEDULE_FAILURE,
    LIST_EMAIL_SCHEDULES_REQUEST,
    LIST_EMAIL_SCHEDULES_SUCCESS,
    LIST_EMAIL_SCHEDULES_FAILURE,
    CLEAR_EMAIL_SCHEDULE_ERRORS
};

export const updateEmailSchedule = (params, callback) => doAction(UPDATE_EMAIL_SCHEDULE_REQUEST, params, callback);
export const updateEmailScheduleSuccess = data => doResponseAction(UPDATE_EMAIL_SCHEDULE_SUCCESS, data);
export const updateEmailScheduleFailure = data => doResponseAction(UPDATE_EMAIL_SCHEDULE_FAILURE, data);

export const listEmailSchedules = (params, callback) => doAction(LIST_EMAIL_SCHEDULES_REQUEST, params, callback);
export const listEmailSchedulesSuccess = data => doResponseAction(LIST_EMAIL_SCHEDULES_SUCCESS, data);
export const listEmailSchedulesFailure = data => doResponseAction(LIST_EMAIL_SCHEDULES_FAILURE, data);

export const clearEmailScheduleErrors = data => doAction(CLEAR_EMAIL_SCHEDULE_ERRORS, data);